import { useState } from 'react';
import { Combobox } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const ComboBox = ({ label, options, value, onChange, displayKey = 'name', disabled = false ,required = false}) => {
  const [query, setQuery] = useState('');

  // If query is empty, show all options; otherwise, filter
  const filteredOptions =
    query === ''
      ? options
      : options.filter((option) =>
          option[displayKey]?.toLowerCase().includes(query.toLowerCase())
        );

  return (
    <>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label} {required ? <span className="text-red-500">*</span>: null}</label>}

      <Combobox value={value} onChange={onChange} disabled={disabled}>
        <div className="relative">
          {/* The input field */}
          <Combobox.Input
            className="w-full p-2 border rounded-lg focus:outline-none"
            onChange={(e) => setQuery(e.target.value)}
            displayValue={(option) => option?.[displayKey] || ''}
          />

          {/* The clickable arrow icon (toggles the options) */}
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-3">
            <FontAwesomeIcon icon={faChevronDown} className="text-tblue" />
          </Combobox.Button>

          {/* The dropdown options */}
          {filteredOptions.length > 0 && (
            <Combobox.Options className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow-lg">
              {filteredOptions.map((option) => (
                <Combobox.Option
                  key={option.id}
                  value={option}
                  className={({ active }) =>
                    `cursor-pointer select-none relative py-2 px-3 ${
                      active ? 'bg-primary text-white' : 'text-gray-900'
                    }`
                  }
                >
                  {({ selected }) => (
                    <span className={`block truncate ${selected ? 'font-bold ' : 'font-normal'}`}>
                      {option[displayKey]}
                    </span>
                  )}
                </Combobox.Option>
              ))}
            </Combobox.Options>
          )}
        </div>
      </Combobox>
    </>
  );
};

export default ComboBox;
